import { render, staticRenderFns } from "./unifiedPurchaseRequestV2.vue?vue&type=template&id=6b8b04cf"
import script from "./unifiedPurchaseRequestV2.vue?vue&type=script&lang=js"
export * from "./unifiedPurchaseRequestV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports